import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getInitialLang = () => {
        const path = window.location.pathname;
        if (path.startsWith('/tr')) return 'tr';
        const savedLang = localStorage.getItem('gnm_lang');
        return savedLang || 'en';
    };

    const [lang, setLang] = useState(getInitialLang());

    // alternatePaths: blog makale detay sayfasında EN↔TR slug çiftini tutar.
    // { en: '/blog/slug-en', tr: '/tr/blog/slug-tr' }
    // Başka sayfalarda null — normal /tr prefix mantığı çalışır.
    const alternatePathsRef = useRef(null);

    // URL ile lang state'ini senkronize et
    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith('/tr') && lang !== 'tr') {
            setLang('tr');
        }
        // Sayfa değiştiğinde alternate path'i sıfırla
        alternatePathsRef.current = null;
    }, [location.pathname]);

    /**
     * BlogPost component'i tarafından çağrılır.
     * Makale yüklendiğinde EN ve TR URL'lerini kaydeder,
     * böylece dil geçişi doğru slug'a yönlendirebilir.
     *
     * @param {{ en: string, tr: string }} paths
     */
    const setAlternatePath = (paths) => {
        alternatePathsRef.current = paths;
    };

    const changeLanguage = (newLang) => {
        setLang(newLang);
        localStorage.setItem('gnm_lang', newLang);

        // Blog makale detay sayfasındaysak ve alternate path kayıtlıysa
        // doğru lokalize slug'a git
        if (alternatePathsRef.current && alternatePathsRef.current[newLang]) {
            navigate(alternatePathsRef.current[newLang], { replace: true });
            return;
        }

        // Diğer tüm sayfalar: basit /tr prefix mantığı
        const currentPath = location.pathname;
        if (newLang === 'tr') {
            if (!currentPath.startsWith('/tr')) {
                const cleanPath = currentPath === '/' ? '' : currentPath;
                navigate('/tr' + cleanPath, { replace: true });
            }
        } else {
            if (currentPath.startsWith('/tr')) {
                const stripped = currentPath.replace('/tr', '');
                navigate(stripped || '/', { replace: true });
            }
        }
    };

    return (
        <LanguageContext.Provider value={{ lang, changeLanguage, setAlternatePath }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
